/**
 * References (testimonials) carousel — Embla, one slide per reference post.
 * Markup: blocks/references.php
 */
import EmblaCarousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';

function initReferencesCarousels() {
	document.querySelectorAll( '[data-carousel-root="references"]' ).forEach( ( root ) => {
		const viewport = root.querySelector( '[data-carousel-viewport]' );
		if ( ! viewport ) {
			return;
		}

		const embla = EmblaCarousel( viewport, { loop: true, align: 'start' }, [
			Autoplay( { delay: 6000, stopOnInteraction: true } ),
		] );

		root.querySelector( '[data-carousel-prev]' )?.addEventListener( 'click', () => embla.scrollPrev() );
		root.querySelector( '[data-carousel-next]' )?.addEventListener( 'click', () => embla.scrollNext() );
	} );
}

initReferencesCarousels();
